<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M3.5 14.5V4H6.5V14.5" stroke="#E5E5E5" stroke-width="1.2" stroke-linecap="round"/>
  <rect x="4.1" y="5.5" width="1.8" height="6.5" rx="0.4" fill="#E5E5E5"/>
  <path d="M7 10L12 8" stroke="#E5E5E5" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M12 8L14 11.5" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <circle cx="14" cy="12" r="1.3" fill="#E5E5E5"/>
</svg>
